// extracted by mini-css-extract-plugin
export default {"preview":"Color_preview__pILGE","invalid":"Color_invalid__YdXr4"};